module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAABHNCSVQICAgIfAhkiAAAAOhJREFUOI2107FOwzAYBOA7K0Pm7mWGbPb/ELDwKBGsbF1Zu/RV4CGcDFUjqk4F5s4ZKh9TpQ5Qp5K52ffJ/n+Z3vtHAK/OuTsUiKSNpBea2R7ATQn0LJ/VCY0xsgBIM0sppbkrgP2aLBxCeDOz2+IwyXtJ6xDCsmma2URXk0ZBsiLZ1nW98963AKpc56oZk5w555ZmtvbePxSDr7iAsk86j6SDpEXf9ysAx0tnJ8GSjgBW4zguhmE4TOlkYUnvJJ9jjB9TwFMtC3ddd3FJf+Xffl4l6Yvk3MxUCpX07VJKraRtQXQL4OkHGbhY4qtNa+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/lessonmenuicon.png
// module id = 647
// module chunks = 0